import { spacePasswordSchema } from "./space-password.js";
import * as z$1 from "zod/v4";
//#region src/schemas/http/space-access-mode.ts
const SPACE_ACCESS_MODES = [
	"public",
	"members_only",
	"public_view_join_password",
	"protected"
];
const SPACE_LINK_JOIN_POLICIES = ["invite_only", "access_mode"];
const spaceLinkJoinPolicySchema = z$1.enum(SPACE_LINK_JOIN_POLICIES);
function spaceAccessModeUsesPassword(accessMode) {
	return accessMode === "public_view_join_password" || accessMode === "protected";
}
const spaceAccessModeSchema = z$1.enum(SPACE_ACCESS_MODES);
const setSpaceAccessModeBodySchema = z$1.strictObject({
	accessMode: spaceAccessModeSchema,
	allowGuests: z$1.boolean().optional(),
	linkJoinPolicy: spaceLinkJoinPolicySchema.optional(),
	password: spacePasswordSchema.optional(),
	visibility: z$1.enum(["public", "private"]).optional()
});
const spaceAccessModeStateSchema = z$1.strictObject({
	spaceId: z$1.string().trim().min(1),
	accessMode: spaceAccessModeSchema,
	passwordProtected: z$1.boolean()
});
//#endregion
export { SPACE_ACCESS_MODES, SPACE_LINK_JOIN_POLICIES, setSpaceAccessModeBodySchema, spaceAccessModeSchema, spaceAccessModeStateSchema, spaceAccessModeUsesPassword, spaceLinkJoinPolicySchema };

//# sourceMappingURL=space-access-mode.js.map